<template>
  <div
    class="absolute transition-all duration-300"
    :style="{
      top: timeslot.position.top,
      left: timeslot.position.left
    }"
  >
    <div
      class="border border-l-4 rounded-lg bg-pure-white p-2 flex flex-col justify-between gap-1 shadow-md transition-all duration-300"
      :style="{
        height: timeslot.element.height,
        width: timeslot.element.width,
        borderColor: timeslot.element.borderColor
      }"
    >
      <div
        class="border border-l-4 rounded-t-lg px-4 w-full absolute top-0 left-0 flex items-center justify-center"
        :style="{
          height: isCompact ? '1.25rem' : '1.625rem',
          borderColor: timeslot.primary_color,
          backgroundColor: timeslot.secondary_color
        }"
        :title="timeslot.title.name"
      >
        <div class="absolute" :style="{ zIndex: 1 }">
          <BlTooltip :tooltip="tooltipText">
            <div
              class="opacity-0"
              :style="{
                height: isCompact ? '1.25rem' : '1.625rem',
                width: `calc(${slotWidth})`
              }"
            ></div>
          </BlTooltip>
        </div>
        <div class="flex justify-center truncate">
          <BlTextBody2
            :text="timeslot.title.name"
            class="truncate"
            :style="{ color: timeslot.primary_color }"
          />
        </div>
      </div>
      <Period
        v-for="item in timeslot.slots"
        :key="item.id"
        :isCompact="isCompact"
        :slotHeight="slotHeight"
        :item="item"
        :therapist="timeslot.therapist"
        :room="timeslot.room"
        :isSelected="selected === timeslot.availability_id"
        :isOpenRoom="!timeslot.title.id"
        @set-selected="$emit('set-selected', timeslot.availability_id)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CLOCK_ROUND } from "@/plugins/assets.js";

import Period from "./Period.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTooltip from "../../BlTooltip.vue";

export default {
  name: "AppointmentsAvailableTimeslot",
  components: {
    Period,
    BlTextBody2,
    BlTooltip
  },
  props: {
    isCompact: { type: Boolean, default: false },
    item: { type: Object, required: true },
    order: { type: Number },
    slotHeight: { type: Number, required: true }, // in rem
    slotWidth: { type: String, required: true },
    selected: { type: Number, default: 0 }
    // @set-selected
  },
  data() {
    return {
      clockRound: CLOCK_ROUND
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter"]),
    enableBranch() {
      return this.currentCenter.enable_branch;
    },
    slotType() {
      // all, therapist, room
      return this.$route.params.tab || "all";
    },
    isOpenRoom() {
      return !this.item.therapist.id;
    },
    tooltipText() {
      if (!this.enableBranch) return "";
      if (!this.timeslot.title.branch) return "";
      return this.timeslot.title.branch.name;
    },
    timeslot() {
      const item = { ...this.item };
      const position = {
        top: "calc(",
        left: "calc(5rem + 5rem"
      };
      const element = {
        height: ``,
        width: `calc(${this.slotWidth} - 2px)`,
        borderColor: item.primary_color
      };

      const indexOfTop = this.clockRound.findIndex(i => {
        const dt = i.split(":")[0];
        return dt === item.start_time_string.split(":")[0];
      });
      position.top += indexOfTop * (this.slotHeight * 2) + "rem";
      if (item.start_time_string.split(":")[1] === "30") {
        position.top += ` + ${this.slotHeight}rem`;
      }
      position.top += " + 0.5px)";

      for (let index = 0; index < this.order; index++) {
        position.left += ` + ${this.slotWidth}`;
      }
      position.left += " + 0.5px)";

      const calculatedHeight =
        this.getSlotCount(item.start_time_string, item.end_time_string) *
        this.slotHeight;
      element.height = `calc(${calculatedHeight}rem - 2px)`;

      const slots = [];
      item.slots.forEach(slot => {
        const lastIndex = slots.findIndex(
          i => i.appointment_id === slot.appointment_id
        );
        if (lastIndex > -1 && slot.appointment_id) {
          slots[lastIndex].end_time_string = slot.end_time_string;
          slots[lastIndex].count += 1;
        } else {
          slots.push({ ...slot, count: 1 });
        }
      });

      let title = { name: "Open room" };
      if (this.slotType === "all" && !this.isOpenRoom) {
        title = item.therapist;
      }
      if (this.slotType === "therapist") {
        title = item.room;
      }
      if (this.slotType === "room" && !this.isOpenRoom) {
        title = item.therapist;
      }
      return { ...item, slots, position, element, title };
    }
  },
  mounted() {},
  methods: {
    getSlotCount(start, end) {
      const s = start.split(":").map(i => Number(i));
      const e = end.split(":").map(i => Number(i));
      let slots = 0;
      slots += (e[0] - s[0]) * 2;
      if (s[1] === 30) slots -= 1;
      if (e[1] === 30) slots += 1;
      return slots;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/appointments/overlapped/AvailableTimeslot.vue